import customerApi from './customer';

export class RestApiService {
  createCustomer = customerApi.createCustomer;
}
